import type { HTMLSerializeOptions } from '@lumapps/wrex/serialization/html/toHTML/types';

import type { THElement } from '../../types';

export const TABLE_ELEMENTS: HTMLSerializeOptions['elements'] = {
    table: (_, children) => `<table>${children}</table>`,
    tr: (_, children) => `<tr>${children}</tr>`,
    td: (_, children) => `<td>${children}</td>`,
    th: (element: THElement, children) => `<th scope="${element.headerType}">${children}</th>`,
};
